import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-pages",
  templateUrl: "./pages.component.html",
  styleUrls: ["./pages.component.scss"],
})
export class PagesComponent implements OnInit {
  sideBar = true;
  constructor() {}

  ngOnInit(): void {}

  openSideBar(event) {
    this.sideBar = !this.sideBar;
  }
}
